<template>
  <div class="flex__between container header-group">
    <div class="icon menu--icon" @click="toggleMenu">
      <font-awesome-icon v-if="getToggled" icon="times" size="2x" />
      <font-awesome-icon v-else icon="bars" size="2x" />
    </div>
    <h1 class="text__bold text__upper text__white">Compliance</h1>
    <LogOut></LogOut>
  </div>
</template>

<script>
import LogOut from "./LogOut";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    LogOut
  },
  computed: {
    ...mapGetters(["getToggled"])
  },
  methods: {
    ...mapActions(["toggleMenu"])
  }
};
</script>

<style scoped lang="scss">
.header-group {
  color: #fff;
  padding-top: 20px;
  padding-bottom: 20px;
  h1 {
    font-size: 1.75rem;
  }
  .icon--menu {
    width: 28px;
    height: 35px;
  }
}
@media (min-width: $lg) {
  .menu--icon {
    visibility: hidden;
  }
}
</style>